<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";
  import type { NavItem } from "$lib/gql/genCms/codegen";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";
  import { linkTo } from "$lib/utils/url";

  export let navItem: NavItem | false = false;
  export let theme: string = "on-surface";
  export let viewAllPath: string = "/";
  export let primaryRoute = false;
  export let lastRoute = false;

  export const dispatch = createEventDispatcher();

  function onClick() {
    dispatch("routeSelect", navItem);
  }

  function onAnchorClick() {
    dispatch("toggleMobileNav");
  }
</script>

<style lang="scss">
  .nav-item-link {
    display: flex;
    text-align: left;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    &--button {
      background: none;
      border: none;
      padding: 0;
      margin: 0;
    }

    &--link {
      text-decoration: none;
    }
  }
</style>

{#if navItem}
  {#if navItem.items && navItem.items.length > 0}
    <button
      type="button"
      class="nav-item-link nav-item-link--button"
      on:click={onClick}
    >
      <Typography
        component="span"
        variant={`${primaryRoute === true ? "button2" : "button1"}`}
        theme={navItem.highlighted ? "brand3" : theme}
      >
        {navItem.title}
      </Typography>
      <Icon icon="chevron_right" color={`var(--on-surface)`} />
    </button>
  {:else if primaryRoute}
    <a
      href={linkTo(navItem.fullPath)}
      on:click={onAnchorClick}
      class="nav-item-link nav-item-link--link"
    >
      <Typography
        component="span"
        variant="button2"
        theme={navItem.highlighted ? "brand3" : theme}
      >
        {navItem.title}
      </Typography>
    </a>
  {:else}
    <a
      href={linkTo(navItem.fullPath)}
      on:click={onAnchorClick}
      class="nav-item-link nav-item-link--link"
    >
      <Typography
        component="span"
        variant="body1"
        theme={navItem.highlighted ? "brand3" : theme}
      >
        {navItem.title}
      </Typography>
    </a>
  {/if}
{:else}
  <a
    href={linkTo(viewAllPath)}
    on:click={onAnchorClick}
    class="nav-item-link nav-item-link--link"
  >
    <Typography
      theme={navItem && navItem.highlighted ? "brand3" : theme}
      component="span"
      variant={`${lastRoute ? "body1" : "button1"}`}
      >{$_("View All")}</Typography
    >
  </a>
{/if}
